import React, { useState, useEffect } from 'react';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import api from './api/client';
import { parse, format } from 'date-fns'; // Добавляем этот импорт


const ScannersNotFullBoxesSB = () => {
    const [scannedData, setScannedData] = useState('');
    const [entries, setEntries] = useState(new Set());
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState([]);

    const parseScannedData = (data) => {
        const lines = data.split('\n').map(line => line.trim()).filter(line => line);
        const parsedEntries = [];
        const errors = [];
    
        lines.forEach((line, index) => {
            try {
                const regex = /(\d+)-Box:(\d+);([^,]+(?:,\s*[^,]+)*)\s(\d{4}\/\d{2}\/\d{2})\s(\d{2}:\d{2}:\d{2})/;
                const match = line.match(regex);
    
                if (!match) {
                    throw new Error(`Row ${index + 1}: Invalid format.`);
                }
    
                const [_, scanner, box, skuData, dateStr, time] = match;
    
                // Преобразование даты
                const parsedDate = parse(dateStr, 'yyyy/MM/dd', new Date());
                if (isNaN(parsedDate)) {
                    throw new Error(`Row ${index + 1}: Invalid date format.`);
                }
                const formattedDate = format(parsedDate, 'yyyy-MM-dd');
    
                // Обработка SKU
                const skus = skuData.split(',').map((skuItem, skuIndex) => {
                    const skuMatch = skuItem.trim().match(/([^/]+)\/(\d+)/);
                    if (!skuMatch) {
                        throw new Error(`Row ${index + 1}: Invalid SKU format in SKU ${skuIndex + 1}.`);
                    }
                    const [__, sku, qty] = skuMatch;
                    return {
                        skunum: skuIndex + 1,
                        sku: sku.trim(),
                        qty: parseInt(qty, 10)
                    };
                });
    
                skus.forEach(({ skunum, sku, qty }) => {
                    parsedEntries.push({
                        scanner: parseInt(scanner, 10),
                        box: parseInt(box, 10),
                        sku,
                        qty,
                        date: formattedDate,
                        time,
                        skunum
                    });
                });
            } catch (error) {
                errors.push(error.message);
            }
        });
    
        if (errors.length > 0) {
            alert(`Errors occurred:\n${errors.join('\n')}`);
        }
    
        return parsedEntries;
    };
    
    const fetchPackNames = async (parsedEntries) => {
        try {
            const uniqueSKUs = [...new Set(parsedEntries.map(entry => entry.sku))]; // Убираем дубликаты SKU
            const responses = await Promise.all(
                uniqueSKUs.map(async (sku) => {
                    const { data } = await api.get(`/api/individualpackets_invboxes?sku=${sku}`);
                    return { sku, packName: data.packName || 'Unknown Pack' };
                })
            );

            const skuToPackNameMap = Object.fromEntries(responses.map(({ sku, packName }) => [sku, packName]));

            return parsedEntries.map(entry => ({
                ...entry,
                packName: skuToPackNameMap[entry.sku] || 'Unknown Pack'
            }));
        } catch (error) {
            console.error('Error fetching pack names:', error);
            return parsedEntries.map(entry => ({ ...entry, packName: 'Unknown Pack' }));
        }
    };
    
    // const openPopup = async () => {
    //     if (!scannedData.trim()) {
    //         alert('Please enter scanned data before viewing.');
    //         return;
    //     }

    //     const parsedEntries = parseScannedData(scannedData);
    //     const enrichedData = await fetchPackNames(parsedEntries);

    //     setPopupData(enrichedData);
    //     setIsPopupOpen(true);
    // };

     // Автоматическое открытие попапа через 1.5 секунды после ввода
     useEffect(() => {
        if (!scannedData.trim()) return; // Если поле пустое, ничего не делаем

        const timer = setTimeout(async () => {
            const parsedEntries = parseScannedData(scannedData);
            const enrichedData = await fetchPackNames(parsedEntries);

            setPopupData(enrichedData);
            setIsPopupOpen(true);
        }, 500); // Ожидание 0.5 секунды после ввода

        return () => clearTimeout(timer); // Сброс таймера при каждом новом вводе
    }, [scannedData]);

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    const removePack = (sku) => {
        setPopupData(prevData => prevData.filter(item => item.sku !== sku));
    };
    
    const handleQtyChange = (sku, newQty) => {
        setPopupData(prevData =>
            prevData.map(item =>
                item.sku === sku ? { ...item, qty: newQty } : item
            )
        );
    };
    

    const handleAddToStock = async () => {
        try {
            const responses = await Promise.all(
                popupData.map(async ({ sku, qty, skunum, box, date, time, scanner }) => {
                    const response = await api.post(`/api/smallbagsinventory_addnotfullbox`, {
                        sku,
                        qty,
                        locationWH: "-",
                        box,
                        skunum,
                        date,
                        time,
                        scanner
                    });
    
                    return response.data; // Возвращаем результат запроса
                })
            );
    
            // Разбираем ответы сервера и формируем сообщение для пользователя
            let successMessages = [];
            let duplicateMessages = [];
    
            responses.forEach(res => {
                if (res.success) {
                    successMessages.push(res.message);
                } else {
                    duplicateMessages.push(res.message);
                }
            });
    
            // Выводим сообщение в зависимости от результата
            if (successMessages.length > 0) {
                alert(`✅ Success:\n${successMessages.join("\n")}`);
            }
    
            if (duplicateMessages.length > 0) {
                alert(`⚠️ Already exists:\n${duplicateMessages.join("\n")}`);
            }
    
            setPopupData([]); // Очищаем попап
            setScannedData(''); // Очищаем текстовое поле
            setIsPopupOpen(false); // Закрываем попап
        } catch (error) {
            console.error('Error updating stock:', error);
            alert('❌ Failed to update stock.');
        }
    };
       

    return (
        <div className="scanners-inv-seeds-page-bg">
            <HeaderLogged />
            <Container>
                <div className="scan-sealed-sets">
                    <h1 className="scan-sealed-sets-h">Scan to add small packets to stock (not full boxes)</h1>
                    <ol className="entries-list">
                        <li>Please Scan QR on the Box with Small Packets</li>
                    </ol>
                    <textarea
                        value={scannedData}
                        onChange={(e) => setScannedData(e.target.value)}
                        placeholder="Scan QR code on the box"
                        className="scanned-input"
                    ></textarea>
                    {/* <button className="save-btn"  onClick={openPopup}>View</button> */}
                    {success && <p style={{ color: 'green' }}>Data saved successfully!</p>}
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </div>
            </Container>
            {isPopupOpen && (
                <div className="popup open">
                    <div className="popup__body">
                        <div className="popup__content">
                            <button className="popup__close-button" onClick={closePopup}>
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 16 16"
                                fill="gray"
                                stroke="gray"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <line x1="1" y1="1" x2="15" y2="15" stroke="gray" strokeWidth="2"/>
                                <line x1="15" y1="1" x2="1" y2="15" stroke="gray" strokeWidth="2"/>
                            </svg>
                            </button>

                            <h2 className="popup__title">Add small packets to stock</h2>

                             <div className="popup__forms--row">
                                <form className="popup__inputs--column">
                                    {popupData.map(({ sku, qty, packName }, index) => (
                                        <div key={index} className="popup__inputs--column">
                                            <label className="label">Packet: {packName}</label>
                                            <label className="label">SKU: {sku}</label>
                                            <input
                                                type="number"
                                                className="form__input"
                                                value={qty}
                                                onChange={(e) => handleQtyChange(sku, parseInt(e.target.value, 10) || 0)} 
                                            />

                                            <button 
                                                type="button"
                                                className="remove-bag-button" 
                                                style={{ color: 'white', marginLeft: '10px' }}
                                                onClick={() => removePack(sku)} 
                                            >
                                                Remove Pack
                                            </button>
                                        </div>
                                    ))}
                                    <button type="button" className="btn btn__green mt-15" onClick={handleAddToStock}>
                                        Add to stock
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                .remove-bag-button{
                    background-color: #F08080;
                    border-radius: 4px;
                    padding: 5px 0;
                }
                .scan-sealed-sets {
                    margin-top: 150px;
                    z-index: 1;
                    position: relative;
                }
                .scan-sealed-sets-h {
                    margin-bottom: 20px;
                    color: #404340;
                    text-transform: uppercase;
                    font-weight: bold;
                }
                .scanned-input {
                    width: 100%;
                    height: 100px;
                    padding: 10px;
                    border: 1px solid #4caf50;
                    border-radius: 5px;
                    margin-bottom: 10px;  
                     z-index: 1;
                     position: relative;
                }
                .add-entry-btn, .save-btn {
                    background-color: #4caf50;
                    color: white;
                    padding: 10px 20px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    margin-top: 10px;
                }
                .add-entry-btn:hover, .save-btn:hover {
                    background-color: #45a049;
                }
                .entries-list {
                    margin-top: 10px;
                    list-style-type: none;
                    padding: 0;
                }
                .entries-list li {
                    background-color: #e8f5e9;
                    padding: 10px;
                    border: 1px solid #c8e6c9;
                    border-radius: 5px;
                    margin-bottom: 5px;
                }
            `}</style>
        </div>
    );
};

export default ScannersNotFullBoxesSB;
